import PEP2026_01    from '../assets/images/PEP_2026/PEPKonf2026_01.webp'
import PEP2026_02    from '../assets/images/PEP_2026/PEPKonf2026_02.webp'
import PEP2026_03    from '../assets/images/PEP_2026/PEPKonf2026_03.webp'
// import PEP2026_04    from '../assets/images/PEP_2026/PEPKonf2026_04.webp'
// import PEP2026_05    from '../assets/images/PEP_2026/PEPKonf2026_05.webp'
// import PEP2026_06    from '../assets/images/PEP_2026/PEPKonf2026_06.webp'
import PEP2026_07    from '../assets/images/PEP_2026/PEPKonf2026_07.webp'
import PEP2026_08    from '../assets/images/PEP_2026/PEPKonf2026_08.webp'
import PEP2026_09    from '../assets/images/PEP_2026/PEPKonf2026_09.webp'
import PEP2026_10    from '../assets/images/PEP_2026/PEPKonf2026_10.webp'
import PEP2026_11    from '../assets/images/PEP_2026/PEPKonf2026_11.webp'
import PEP2026_11_01 from '../assets/images/PEP_2026/PEPKonf2026_11_01.webp'
import PEP2026_11_02 from '../assets/images/PEP_2026/PEPKonf2026_11_02.webp'
import PEP2026_12    from '../assets/images/PEP_2026/PEPKonf2026_12.webp'
import PEP2026_13    from '../assets/images/PEP_2026/PEPKonf2026_13.webp'
import PEP2026_14    from '../assets/images/PEP_2026/PEPKonf2026_14.webp'
import PEP2026_15    from '../assets/images/PEP_2026/PEPKonf2026_15.webp'
import PEP2026_16    from '../assets/images/PEP_2026/PEPKonf2026_16.webp'
import PEP2026_17    from '../assets/images/PEP_2026/PEPKonf2026_17.webp'

import PEP2025_01 from '../assets/images/PEP_2025/PEPKonf2025_01.webp'
import PEP2025_02 from '../assets/images/PEP_2025/PEPKonf2025_02.webp'
import PEP2025_03 from '../assets/images/PEP_2025/PEPKonf2025_03.webp'
import PEP2025_04 from '../assets/images/PEP_2025/PEPKonf2025_04.webp'
import PEP2025_05 from '../assets/images/PEP_2025/PEPKonf2025_05.webp'
import PEP2025_06 from '../assets/images/PEP_2025/PEPKonf2025_06.webp'
import PEP2025_07 from '../assets/images/PEP_2025/PEPKonf2025_07.webp'
import PEP2025_08 from '../assets/images/PEP_2025/PEPKonf2025_08.webp'
import PEP2025_09 from '../assets/images/PEP_2025/PEPKonf2025_09.webp'
import PEP2025_10 from '../assets/images/PEP_2025/PEPKonf2025_10.webp'
import PEP2025_11 from '../assets/images/PEP_2025/PEPKonf2025_11.webp'
import PEP2025_12 from '../assets/images/PEP_2025/PEPKonf2025_12.webp'
import PEP2025_13 from '../assets/images/PEP_2025/PEPKonf2025_13.webp'
// import PEP2025_13_01 from '../assets/images/PEP_2025/PEPKonf2025_13_01.webp'
import PEP2025_13_02 from '../assets/images/PEP_2025/PEPKonf2025_13_02.webp'
// import PEP2025_13_03 from '../assets/images/PEP_2025/PEPKonf2025_13_03.webp'
import PEP2025_13_04 from '../assets/images/PEP_2025/PEPKonf2025_13_04.webp'
import PEP2025_14 from '../assets/images/PEP_2025/PEPKonf2025_14.webp'
import PEP2025_15 from '../assets/images/PEP_2025/PEPKonf2025_15.webp'
import PEP2025_16 from '../assets/images/PEP_2025/PEPKonf2025_16.webp'
import PEP2025_17 from '../assets/images/PEP_2025/PEPKonf2025_17.webp'
import PEP2025_18 from '../assets/images/PEP_2025/PEPKonf2025_18.webp'

import PEP2024_01 from '../assets/images/PEP_2024/PEPKonf2024_01.webp'
import PEP2024_02 from '../assets/images/PEP_2024/PEPKonf2024_02.webp'
import PEP2024_03 from '../assets/images/PEP_2024/PEPKonf2024_03.webp'
import PEP2024_04 from '../assets/images/PEP_2024/PEPKonf2024_04.webp'
import PEP2024_06 from '../assets/images/PEP_2024/PEPKonf2024_06.webp'
import PEP2024_07 from '../assets/images/PEP_2024/PEPKonf2024_07.webp'
import PEP2024_08 from '../assets/images/PEP_2024/PEPKonf2024_08.webp'
import PEP2024_09 from '../assets/images/PEP_2024/PEPKonf2024_09.webp'
// import PEP2024_10 from '../assets/images/PEP_2024/PEPKonf2024_10.webp'
import PEP2024_11 from '../assets/images/PEP_2024/PEPKonf2024_11.webp'
import PEP2024_12 from '../assets/images/PEP_2024/PEPKonf2024_12.webp'
import PEP2024_13 from '../assets/images/PEP_2024/PEPKonf2024_13.webp'
import PEP2024_14 from '../assets/images/PEP_2024/PEPKonf2024_14.webp'
import PEP2024_15 from '../assets/images/PEP_2024/PEPKonf2024_15.webp'

import PEP2023_01 from '../assets/images/PEP_2023/PEPKonf2023_01.webp'
import PEP2023_02 from '../assets/images/PEP_2023/PEPKonf2023_02.webp'
// import PEP2023_03 from '../assets/images/PEP_2023/PEPKonf2023_03.webp'
import PEP2023_04 from '../assets/images/PEP_2023/PEPKonf2023_04.webp'
import PEP2023_05 from '../assets/images/PEP_2023/PEPKonf2023_05.webp'
// import PEP2023_06 from '../assets/images/PEP_2023/PEPKonf2023_06.webp'
import PEP2023_07 from '../assets/images/PEP_2023/PEPKonf2023_07.webp'
import PEP2023_08 from '../assets/images/PEP_2023/PEPKonf2023_08.webp'
import PEP2023_09 from '../assets/images/PEP_2023/PEPKonf2023_09.webp'
import PEP2023_10 from '../assets/images/PEP_2023/PEPKonf2023_10.webp'
// import PEP2023_11 from '../assets/images/PEP_2023/PEPKonf2023_11.webp'
import PEP2023_12 from '../assets/images/PEP_2023/PEPKonf2023_12.webp'
import PEP2023_13 from '../assets/images/PEP_2023/PEPKonf2023_13.webp'
import PEP2023_14 from '../assets/images/PEP_2023/PEPKonf2023_14.webp'
import PEP2023_15 from '../assets/images/PEP_2023/PEPKonf2023_15.webp'
import PEP2023_16 from '../assets/images/PEP_2023/PEPKonf2023_16.webp'
import PEP2023_17 from '../assets/images/PEP_2023/PEPKonf2023_17.webp'

export const slike =
{
    2026:
    [
        { src: PEP2026_01,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_02,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_03,    title: 'PEPKonf 2026', description: '' },
        // { src: PEP2026_04,    title: 'PEPKonf 2026', description: '' },
        // { src: PEP2026_05,    title: 'PEPKonf 2026', description: '' },
        // { src: PEP2026_06,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_07,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_08,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_09,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_10,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_11,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_11_01, title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_11_02, title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_12,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_13,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_14,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_17,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_15,    title: 'PEPKonf 2026', description: '' },
        { src: PEP2026_16,    title: 'PEPKonf 2026', description: '' },
    ],
    2025:
    [
        { src: PEP2025_14,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_13,    title: 'PEPKonf 2025', description: '' },
        // { src: PEP2025_13_01, title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_02,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_01,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_03,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_04,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_05,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_06,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_07,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_08,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_09,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_10,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_11,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_12,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_13_02, title: 'PEPKonf 2025', description: '', objectPosition: 'left center' },
        // { src: PEP2025_13_03, title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_13_04, title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_15,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_16,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_17,    title: 'PEPKonf 2025', description: '' },
        { src: PEP2025_18,    title: 'PEPKonf 2025', description: '' },
    ],
    2024:
    [
        { src: PEP2024_06, title: 'PEPKonf 2024', description: 'Sudionici PEP Konferencije 2024 u amfiteatru Sveučilišta u Dubrovniku' },
        { src: PEP2024_03, title: 'PEPKonf 2024', description: 'Jadran Kapor glavni urednik Dubrovačkog vijesnika, RTL reporterka Donna Diana Prčić, dopisnica Nove TV u Dubrovniku Paula Klaić Saulačić i moderator Mislav Ćimić' },
        { src: PEP2024_07, title: 'PEPKonf 2024', description: 'Jadran Kapor, Donna Diana Prčić i Paula Klaić Saulačić na pozornici na panelu' },
        { src: PEP2024_04, title: 'PEPKonf 2024', description: 'Jadran Kapor, Mislav Ćimić i Donna Diana Prčić na pozornici PEP Konferencije 2024' },
        { src: PEP2024_08, title: 'PEPKonf 2024', description: 'Kristijan Sedak u predavaoinici, plakat s PEP KONF logom' },
        { src: PEP2024_09, title: 'PEPKonf 2024', description: 'Gloria Mage Gospić CEO Komunikativne komunikacije na PEP Konferenciji 2024' },
        // { src: PEP2024_10, title: 'PEPKonf 2024', description: 'Gloria Mage Gospić CEO Komunikativne komunikacije na PEP Konferenciji 2024 u predavaoinici s sudionicima' },
        { src: PEP2024_11, title: 'PEPKonf 2024', description: 'Iva Sentić, vlasnica Dubrovnik Event predavačica PEP Konferencije 2024' },
        { src: PEP2024_02, title: 'PEPKonf 2024', description: 'Organizatori PEP Konferencije 2024 na pozornici' },
        { src: PEP2024_01, title: 'PEPKonf 2024', description: 'Moderatori PEP Konferencije 2024 na pozornici' },
        { src: PEP2024_13, title: 'PEPKonf 2024', description: 'Organizatori PEP Konferencije zajedno s predavačima' },
        { src: PEP2024_14, title: 'PEPKonf 2024', description: 'Svi organizatori PEP Konferencije i predavači zajedno na slici' },
        { src: PEP2024_15, title: 'PEPKonf 2024', description: 'Organizatori PEP Konferencije 2024 ispred amfiteatra u Sveučilištu u Dubrovniku' },
        { src: PEP2024_12, title: 'PEPKonf 2024', description: 'Organizatori PEP Konferencije zajedno s Kristijanom Sedakom' },
    ],
    2023:
    [
        { src: PEP2023_07, title: 'PEPKonf 2023', description: 'Sudionici PEP Konferencije 2023 u prostoriji učionice Sveučilišta u Dubrovniku' },
        { src: PEP2023_01, title: 'PEPKonf 2023', description: 'Krešimir Macan iz Manjgure, predavač PEP Konferencije 2023', objectPosition: 'right center' },
        { src: PEP2023_02, title: 'PEPKonf 2023', description: 'Krešimir Macan iz Manjgure, predavač PEP Konferencije 2023 u sobi punoj posjetitlja', objectPosition: 'left center' },
        // { src: PEP2023_03, title: 'PEPKonf 2023', description: 'Marija Pajić Bačić iz Maripa Medija, predavačica PEP Konferencije 2023, PEP KONF plakat i logo iza nje' },
        { src: PEP2023_04, title: 'PEPKonf 2023', description: 'Marija Pajić Bačić iz Maripa Medija, predavačica PEP Konf 2023 u prostoriji punoj sudionika', objectPosition: 'right center' },
        { src: PEP2023_05, title: 'PEPKonf 2023', description: 'Luka Šipić iz Vrh Komunikacije, predavač PEP Konferencije 2023' },
        // { src: PEP2023_06, title: 'PEPKonf 2023', description: 'Luka Šipić iz Vrh Komunikacije, predavač PEP Konferencije 2023, plakat s PEP KONF logom iza njega' },
        { src: PEP2023_08, title: 'PEPKonf 2023', description: 'Ana Antunović iz ProjektANA, predavačica PEP Konferencije 2023' },
        { src: PEP2023_09, title: 'PEPKonf 2023', description: 'Romana Malohodžić iz Odjseka za protokol Grada Dubrovnika, predavačica PEP Konferencije 2023' },
        { src: PEP2023_10, title: 'PEPKonf 2023', description: 'Kiti Iveta iz PRiredba Studija, predavačica PEP Konferencije 2023' },
        // { src: PEP2023_11, title: 'PEPKonf 2023', description: 'Kiti Iveta iz PRiredba Studija, predavačica PEP Konferencije 2023, plakat s logom PEP KONF iza nje' },
        { src: PEP2023_12, title: 'PEPKonf 2023', description: 'Anđela Matić iz Event Lab-a, predavačica PEP Konferencije 2023', objectPosition: 'right center' },
        { src: PEP2023_15, title: 'PEPKonf 2023', description: 'Organizatori PEP Konferencije 2023' },
        { src: PEP2023_13, title: 'PEPKonf 2023', description: 'Organizatori PEP Konferencije zajedno s predavačima Krešimirom Macanom i Lukom Šipićem' },
        { src: PEP2023_14, title: 'PEPKonf 2023', description: 'Organizatorice PEP Konferencije zajedno s Lukom Šipićem, predavačem' },
        { src: PEP2023_16, title: 'PEPKonf 2023', description: 'Organizatori PEP Konferencije 2023 zajedno s dekanicom Fakulteta za medije i odnose s javnošću, doc. dr. sc. Romanom John' },
        { src: PEP2023_17, title: 'PEPKonf 2023', description: 'Dekanica Romana John, Mislav Ćimić moderator i Anđela Matić predavačica zajedno na slici' },
    ]
}